import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Layout from "../components/Layout";

export default function AddInterview() {
  const [company, setCompany] = useState("");
  const [position, setPosition] = useState("");
  const [date, setDate] = useState("");
  const [status, setStatus] = useState("Scheduled"); // Default value
  const [startTime, setStartTime] = useState(""); // Optional
  const [endTime, setEndTime] = useState(""); // Optional
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // ✅ Combine date + time into proper ISO format
      const startISO =
        startTime && date ? new Date(`${date}T${startTime}:00Z`).toISOString() : null;
      const endISO =
        endTime && date ? new Date(`${date}T${endTime}:00Z`).toISOString() : null;

      const res = await api.post("/interviews", {
        company,
        position,
        date,
        status,
        startTime: startISO,
        endTime: endISO,
      });

      const newInterviewId = res.data.id;
      alert("✅ Interview created! Redirecting to setup...");

      // 🚀 Redirect to Setup Wizard instead of Interview Details
      navigate(`/interviews/${newInterviewId}/questions`);
    } catch (err) {
      console.error(
        "❌ Failed to create interview:",
        err.response?.data || err.message
      );
      alert("Failed to create interview");
    }
  };

  return (
    <Layout>
      <h2 className="text-2xl font-bold mb-4">Add New Interview</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          className="border px-3 py-2 w-full rounded"
          placeholder="Company"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          required
        />
        <input
          className="border px-3 py-2 w-full rounded"
          placeholder="Position"
          value={position}
          onChange={(e) => setPosition(e.target.value)}
          required
        />

        {/* Date Picker with hint */}
        <div>
          <input
            className="border px-3 py-2 w-full rounded"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
          <small className="text-gray-500">📅 Format: DD-MM-yyy</small>
        </div>

        <select
          className="border px-3 py-2 w-full rounded"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="Scheduled">Scheduled</option>
          <option value="Pending">Pending</option>
          <option value="Completed">Completed</option>
        </select>

        {/* Optional Start Time with hint */}
        <div>
          <input
            className="border px-3 py-2 w-full rounded"
            type="time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            placeholder="Start Time (optional)"
          />
          <small className="text-gray-500">⏰ Format: HH:MM (Optional Interview start time)</small>
        </div>

        {/* Optional End Time with hint */}
        <div>
          <input
            className="border px-3 py-2 w-full rounded"
            type="time"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            placeholder="End Time (optional)"
          />
          <small className="text-gray-500">⏰ Format: HH:MM (Optional Interview End time)</small>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Interview
        </button>
      </form>
    </Layout>
  );
}
